module.exports = __webpack_public_path__ + "media/shape/list-babd361b.png";